export default "__VITE_ASSET__BzRh6o2F__"